module.exports = __webpack_public_path__ + "img/income-protection-providers.b3d9ec0.webp";